<template>
  <div class="container">
    <h1 class="text-center text--blue">Account Deletion</h1>
    <p>
      We offer login via Apple and Google accounts, so we do not store your
      password or any sensitive information.
    </p>
    <p>
      Logging in allows us to save your game progress and backups. You can still
      play the game without an account, but your progress won’t be saved, and
      you’ll lose your data if you uninstall the app or switch devices.
    </p>
    <p>
      If you’d like to delete your account and associated data from the Brain
      Twist app, you can do so in one of the following ways:
    </p>

    <h2>Option 1: In-App Deletion</h2>
    <p>
      Open the app and go to: <strong>Settings &gt; Delete Account</strong>.
    </p>

    <h2>Option 2: Contact Us</h2>
    <p>
      Email us at
      <a href="mailto:contact@quormotion.com">contact@quormotion.com</a> with
      your account email and a deletion request.
    </p>

    <h2>What Will Be Deleted</h2>
    <ul>
      <li>Your account information (email or user ID)</li>
      <li>Your saved game progress and cloud backups</li>
    </ul>

    <h2>What We Retain</h2>
    <p>
      We may retain anonymized usage data and crash logs for diagnostic
      purposes. This data is no longer linked to your identity.
    </p>
    <p>All deletion requests are processed within 7 days.</p>
  </div>
</template>

<style lang="scss">
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
h1 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}
p {
  font-size: 1.2rem;
  margin-bottom: 1rem;
}
</style>
